import { shape, oneOf } from "prop-types";

const values = [
	0,
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	12,
	13,
	14,
	15,
	16,
	17,
	18,
	19,
	20,
	21,
	22,
	23,
	24,
	25,
	26,
	27,
	28,
	29,
	30,
	31,
	32,
	33,
	34,
	35,
	36,
	37,
	38,
	39,
	40,
	41,
	42,
	43,
	44,
	45,
	46,
	47,
	48,
	49,
	50,
	51,
	52,
	53,
	54,
	55,
	56,
	57,
	58,
	59,
	60,
	61,
	62,
	63,
	64,
	"auto",
	"m1",
	"m2",
	"m3",
	"m4",
	"m5",
	"m6",
	"m7",
	"m8",
	"m9",
	"m10",
	"m11",
	"m12",
	"m13",
	"m14",
	"m15",
	"m16",
	"m17",
	"m18",
	"m19",
	"m20",
	"m21",
	"m22",
	"m23",
	"m24",
	"m25",
	"m26",
	"m27",
	"m28",
	"m29",
	"m30",
	"m31",
	"m32",
	"m33",
	"m34",
	"m35",
	"m36",
	"m37",
	"m38",
	"m39",
	"m40",
	"m41",
	"m42",
	"m43",
	"m44",
	"m45",
	"m46",
	"m47",
	"m48",
	"m49",
	"m50",
	"m51",
	"m52",
	"m53",
	"m54",
	"m55",
	"m56",
	"m57",
	"m58",
	"m59",
	"m60",
	"m61",
	"m62",
	"m63",
	"m64",
];

const maskProps = {
	m: null,
	mr: null,
	ml: null,
	mt: null,
	mb: null,
	mx: null,
	my: null,
	p: null,
	pr: null,
	pl: null,
	pt: null,
	pb: null,
	px: null,
	py: null,
};

const maskPropTypes = {
	m: oneOf(values),
	mr: oneOf(values),
	ml: oneOf(values),
	mt: oneOf(values),
	mb: oneOf(values),
	mx: oneOf(values),
	my: oneOf(values),
	p: oneOf(values),
	pr: oneOf(values),
	pl: oneOf(values),
	pt: oneOf(values),
	pb: oneOf(values),
	px: oneOf(values),
	py: oneOf(values),
};

export const spacingProps = {
	...maskProps,
	sm: {
		...maskProps,
	},
	md: {
		...maskProps,
	},
	lg: {
		...maskProps,
	},
};

export const spacingPropTypes = shape({
	...maskPropTypes,
	sm: shape({
		...maskPropTypes,
	}),
	md: shape({
		...maskPropTypes,
	}),
	lg: shape({
		...maskPropTypes,
	}),
});

const checkValue = value => values.indexOf(value) !== -1;

export const spacingClassName = ({ ...props }) => {
	const { sm, md, lg, m, mr, ml, mt, mb, mx, my, p, pr, pl, pt, pb, px, py } = props;

	// TODO: refactor to make code more concise
	return [
		checkValue(m) && `m-${m}`,
		checkValue(mr) && `mr-${mr}`,
		checkValue(ml) && `ml-${ml}`,
		checkValue(mt) && `mt-${mt}`,
		checkValue(mb) && `mb-${mb}`,
		checkValue(mx) && `mx-${mx}`,
		checkValue(my) && `my-${my}`,
		checkValue(p) && `p-${p}`,
		checkValue(pr) && `pr-${pr}`,
		checkValue(pl) && `pl-${pl}`,
		checkValue(pt) && `pt-${pt}`,
		checkValue(pb) && `pb-${pb}`,
		checkValue(px) && `px-${px}`,
		checkValue(py) && `py-${py}`,

		sm && checkValue(sm.m) && `m-${sm.m}--sm`,
		sm && checkValue(sm.mr) && `mr-${sm.mr}--sm`,
		sm && checkValue(sm.ml) && `ml-${sm.ml}--sm`,
		sm && checkValue(sm.mt) && `mt-${sm.mt}--sm`,
		sm && checkValue(sm.mb) && `mb-${sm.mb}--sm`,
		sm && checkValue(sm.mx) && `mx-${sm.mx}--sm`,
		sm && checkValue(sm.my) && `my-${sm.my}--sm`,
		sm && checkValue(sm.p) && `p-${sm.p}--sm`,
		sm && checkValue(sm.pr) && `pr-${sm.pr}--sm`,
		sm && checkValue(sm.pl) && `pl-${sm.pl}--sm`,
		sm && checkValue(sm.pt) && `pt-${sm.pt}--sm`,
		sm && checkValue(sm.pb) && `pb-${sm.pb}--sm`,
		sm && checkValue(sm.px) && `px-${sm.px}--sm`,
		sm && checkValue(sm.py) && `py-${sm.py}--sm`,

		md && checkValue(md.m) && `m-${md.m}--md`,
		md && checkValue(md.mr) && `mr-${md.mr}--md`,
		md && checkValue(md.ml) && `ml-${md.ml}--md`,
		md && checkValue(md.mt) && `mt-${md.mt}--md`,
		md && checkValue(md.mb) && `mb-${md.mb}--md`,
		md && checkValue(md.mx) && `mx-${md.mx}--md`,
		md && checkValue(md.my) && `my-${md.my}--md`,
		md && checkValue(md.p) && `p-${md.p}--md`,
		md && checkValue(md.pr) && `pr-${md.pr}--md`,
		md && checkValue(md.pl) && `pl-${md.pl}--md`,
		md && checkValue(md.pt) && `pt-${md.pt}--md`,
		md && checkValue(md.pb) && `pb-${md.pb}--md`,
		md && checkValue(md.px) && `px-${md.px}--md`,
		md && checkValue(md.py) && `py-${md.py}--md`,

		lg && checkValue(lg.m) && `m-${lg.m}--lg`,
		lg && checkValue(lg.mr) && `mr-${lg.mr}--lg`,
		lg && checkValue(lg.ml) && `ml-${lg.ml}--lg`,
		lg && checkValue(lg.mt) && `mt-${lg.mt}--lg`,
		lg && checkValue(lg.mb) && `mb-${lg.mb}--lg`,
		lg && checkValue(lg.mx) && `mx-${lg.mx}--lg`,
		lg && checkValue(lg.my) && `my-${lg.my}--lg`,
		lg && checkValue(lg.p) && `p-${lg.p}--lg`,
		lg && checkValue(lg.pr) && `pr-${lg.pr}--lg`,
		lg && checkValue(lg.pl) && `pl-${lg.pl}--lg`,
		lg && checkValue(lg.pt) && `pt-${lg.pt}--lg`,
		lg && checkValue(lg.pb) && `pb-${lg.pb}--lg`,
		lg && checkValue(lg.px) && `px-${lg.px}--lg`,
		lg && checkValue(lg.py) && `py-${lg.py}--lg`,
	];
};
